import React from 'react';
import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import LoginCard from '../ui/LoginCard';
import AltLayout from '../ui/Layout/AltLayout';
import darkCurve from '../assets/svg/dark-curve.svg';
import withContentfulTag from '../utils/withContentfulTag';
import { contentfulPropTypes } from '../propTypes';

const DarkDiv = styled.div`
  background: #0c1f28;

  h1 {
    color: #fff;
    font-size: 56px;
    margin-bottom: 40px;
  }

  h2 {
    color: #fff;
    font-size: 22px;
    margin: 0 auto 40px;
    max-width: 600px;
  }
`;

const DarkBgDiv = styled.div`
  background-image: url(${darkCurve});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
`;

const ConstrainedDiv = styled.div`
  max-width: 450px;
  margin: 0 auto 30px;

  h1 {
    size: 48px;
    max-width: 300px;
    margin: 0 auto;

    &:nth-child(2) {
      margin-bottom: 30px;
    }
  }
`;

export const DownloadContainer = ({ contentful, loading, fetched }) => (
  <AltLayout>
    {!loading && fetched && (
      <div className="w-100 flex-column">
        <DarkDiv className="w-100 text-center pb-3">
          <Container fluid="lg" className="pt-5">
            <h1>{contentful?.title}</h1>
            <h2>{contentful?.subtitle}</h2>
          </Container>
        </DarkDiv>
        <DarkBgDiv className="w-100 pb-3">
          <Container fluid="lg" className="align-items-center">
            <ConstrainedDiv>
              <LoginCard>
                <ReactMarkdown>{contentful?.body}</ReactMarkdown>
              </LoginCard>
            </ConstrainedDiv>
          </Container>
        </DarkBgDiv>
      </div>
    )}
  </AltLayout>
);

DownloadContainer.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(DownloadContainer, 'web_app_download_page');
